export default function isCancelledRequestError(error: unknown): boolean {
  if (!error) return false;

  if (typeof error === 'object') {
    const name = 'name' in error && typeof error.name === 'string' ? error.name.toLowerCase() : '';
    const code = 'code' in error && typeof error.code === 'string' ? error.code.toLowerCase() : '';

    if (name === 'aborterror' || code === 'err_canceled') {
      return true;
    }
  }

  let message = '';
  if (error instanceof Error) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  } else {
    message = JSON.stringify(error);
  }

  const normalizedMessage = message.toLowerCase();

  return normalizedMessage.includes('cancelled')
    || normalizedMessage.includes('canceled')
    || normalizedMessage.includes('aborted')
    || normalizedMessage.includes('aborterror')
    || normalizedMessage.includes('signal is aborted');
}
